import Splide from '@splidejs/splide';

export function startHome(){

    if(document.querySelector("main#home")){

        let homeGallery = new Splide('.heroGallery',{
            type: "fade",
            height: '100vh',
            arrows:false,
            autoplay:true,
            speed:650,
            rewind:true,
            cover:true
        })
        homeGallery.mount()

        let header = document.querySelector('header#mainHeader nav')
        let headerHeight = header.offsetHeight

        // Gallery text vertical position
        let galleryText = document.querySelector('.galleryText')
        galleryText.style.paddingTop = headerHeight+'px'


        let categoriesGallery = new Splide('.categoriesGallery',{
            type:"slide",
            perPage:window.screen.width >= 750?3:1,
            perMove: 1,
            gap: "1em"
        })
        categoriesGallery.mount()

        let homeObserver = new IntersectionObserver(onIntersection,{
            root:null,
            threshold:.5
        })

        function onIntersection(entries,opts){
            
            entries.forEach(entry => {
                if(entry.isIntersecting) 
                    entry.target.classList.add('active')
            });
        }

        homeObserver.observe(document.querySelector('#slideIn'))
        homeObserver.observe(document.querySelector('#productSplideTrack'))

    }

    return

}


function isScrolledIntoView(el) {
    var rect = el.getBoundingClientRect();
    var elemTop = rect.top;
    var elemBottom = rect.bottom;

    // Only completely visible elements return true:
    var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
    // Partially visible elements return true:
    //isVisible = elemTop < window.innerHeight && elemBottom >= 0;
    return isVisible;
}